import { ReactNode, useMemo } from 'react'

import { Stack } from '@mui/material'

import { EditTimeWindow } from './components/EditTimeWindow'

import { useActions } from './hooks/useActions'

interface Props {
  onUpdateTimeWindow: (timeWindow: uui.domain.rm.TimeWindow, timeWindowIndex: 0 | 1) => void
  onRemoveTimeWindow: (timeWindowIndex: 0 | 1) => void
  validate: (force?: boolean) => void
  value: [uui.domain.rm.TimeWindow?, uui.domain.rm.TimeWindow?]
  error: boolean
  helperText: ReactNode
  disabled?: boolean
}

export function EditTimeWindows(props: Props) {
  const { value, onRemoveTimeWindow, validate, disabled, onUpdateTimeWindow, error, helperText } =
    props
  const [tw1, tw2] = value

  const actions = useActions(onUpdateTimeWindow, onRemoveTimeWindow)

  // Parse helperText for individual time window errors
  const errors = useMemo<string[]>(() => {
    if (typeof helperText === 'string') {
      try {
        return JSON.parse(helperText) as string[]
      } catch {
        return []
      }
    }
    return []
  }, [helperText])

  return (
    <Stack spacing={2}>
      {!!tw1 && (
        <EditTimeWindow
          value={tw1}
          onRemoveTimeWindow={actions.onRemoveTimeWindow1}
          onUpdateTimeWindow={actions.onUpdateTimeWindow1}
          validate={validate}
          disabled={disabled}
          errorMessage={errors[0] || undefined}
          hasError={error && !!errors[0]}
        />
      )}
      {!!tw2 && (
        <EditTimeWindow
          value={tw2}
          onRemoveTimeWindow={actions.onRemoveTimeWindow2}
          onUpdateTimeWindow={actions.onUpdateTimeWindow2}
          validate={validate}
          disabled={disabled}
          errorMessage={errors[1] || undefined}
          hasError={error && !!errors[1]}
        />
      )}
    </Stack>
  )
}
